<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-balances'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('new')} ${$t('balances')}`"
    :searchButton="true"
    :searchFlag="searchFlag"
    :badgeButtons="
      filterExists
        ? [
            {
              text: 'Reset Filters',
              value: 'reset_filters',
              icon: 'delete-white'
            }
          ]
        : []
    "
    @add_click="onAddBalance"
    @searchClick="onSearchClick"
    @badgeClick="onBadgeClick"
  >
    <div v-if="searchFlag" class="search-controls">
      <InputField
        :value="searchString"
        :placeholder="'Search'"
        :config="{
          borderStyle: 'bottom',
          width: '124px'
        }"
        @keyup="onSearchInputKeyup"
      ></InputField>
    </div>
    <!-- <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined
      }"
    > -->
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-balances-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedContractDetails.balances || []"
      :showNoItems="false"
      @scrollnext="onListScroll"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('balances')">
            <DatePicker2
              :disabled="item['editable'] == 'yes' ? false : true"
              id="balance_date"
              :label="$t('balance_date')"
              :showLabel="false"
              :value="item['balance_date']"
              :bb="'0px'"
              @input="e => onDateUpdate(e, item)"
            />
          </td>
          <td v-bind="tdcon('description')">
            <TextField2
              :disabled="item['editable'] == 'yes' ? false : true"
              :id="'description'"
              :showLabel="false"
              :value="item['description']"
              :bb="'0px'"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('type')">
            <Dropdown2
              :disabled="item['editable'] == 'yes' ? false : true"
              class="dbox1"
              :showLabel="false"
              :options="balanceTypeTV"
              :selected="balanceTypeTV.find(e => e.value == item.balance_type)"
              :placeholder="$t('balance_type')"
              :bb="'0px'"
              v-on:selectedChange="
                e => onDropdownChange('balance_type', e, item)
              "
            />
          </td>
          <td v-bind="tdcon('amount')">
            <TextField2
              :disabled="item['editable'] == 'yes' ? false : true"
              :ta="'right'"
              :id="'amount'"
              :showLabel="false"
              :value="item['amount']"
              :bb="'0px'"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              v-if="
                item['editable'] == 'yes' ? true : false && item['balance_date']
              "
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteBalance(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
    <!-- </div> -->
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContractsService } from "../../services/contracts.service";
import { mapActionObject } from "../../../../store/global";
import { contractsRoyaltyActions } from "../../store/contracts/actions";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedContractDetails"],
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        scrollNextThreshold:95
      }),

      searchFlag: false,
      searchString: "",
      searchSubject: new Subject(),
      scrollSubject:new Subject(),
      balanceList: [],
      start:0,

      searchModel: {
        str: "",
        balance_type: ""
      }
    };
  },
  mounted: async function() {
    subscribeSubject(this, this.scrollSubject, (res) => {
      const type_str = "1,2,3,4";
      ContractsService.fetchDetailsTabBalances(
        this.contract_id,
        type_str,
        res.start
      ).then((res) => {
        this.$emit("fetch", res.data.balances );
      });
    });
    // Balances Subscription
    subscribeSubject(this, this.searchSubject, () => {
      this.findBalanceList();
    });
  },
  computed: {
    headers: function() {
      return [
        createTableHeader("balances", { mw: 140 }),
        createTableHeader("description"),
        createTableHeader("type", { f: 0.6 }),
        createTableHeader("amount", {
          f: 0.5,
          text: `${this.$t("amount")} ${
            this.$store.getters.account.client.default_currency
          }`,
          ta: "right"
        }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    },

    balanceTypeTV: function() {
      return [
        { text: "Advance", value: "1" },
        { text: "Recoupable", value: "2" },
        { text: "Credit Return Reserve", value: "3" },
        { text: "Closing Balance", value: "4" }
      ];
    },

    filterExists() {
      return this.searchString != "";
    }
  },
  methods: {
    ...mapActionObject(storeNS, contractsRoyaltyActions),

    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },
    onListScroll: function (value) {
      console.log("OOO");
      this.start = this.start + 30;
      this.scrollSubject.next({ start: this.start });
    },
    onDropdownChange: function(name, e, item) {
      this.$emit("changed", { name, value: e.value, item });
    },

    onDateUpdate: function({ name, value }, item) {
      // console.log({
      //   olddate: new Date(this.selectedContractDetails.max_end_date).getTime(),
      //   "item.balance_date": new Date(item.balance_date),
      //   newd: new Date(value).getTime()
      // });

      if (
        new Date(this.selectedContractDetails.max_end_date).getTime() <=
        new Date(value).getTime()
      ) {
        console.log("date ");
        this.$emit("changed", {
          name,
          value,
          item
        });
      } else {
        // this.$emit("changed", {
        //   name,
        //   value: OLDVALUE,
        //   item
        // });
        NotificationService.showNotification({
          text: `Date must be after ${
            this.selectedContractDetails.max_end_date
          }`,
          timeout: 1500,
          type: "error"
        });
      }

      // max_end_date	"2022-03-31"
    },

    onAddBalance: async function() {
      const res = await ContractsService.addBalance({
        contract_id: this.contract_id,
        type_str: "1,2,3,4"
      });
      this.$emit("added", res.data);
    },



    // onkeyup => this.searchString = value; subject next
    // SubscribeSubject((searchString) => )
    // Emit
    // Sidewindow - Action Set.all searchString
    // Action - Fetch + UpdateNavTab

    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      this.searchSubject.next(this.searchString);
    },

    findBalanceList: async function() {
      const res = await ContractsService.searchBalance({
        contract_id: this.contract_id,
        type_str: "1,2,3,4",
        str: this.searchString
      });
      this.balanceList = res.data || [];
      this.$emit("searched", this.balanceList);
    },
    onSearchClick: function() {
      this.searchFlag = !this.searchFlag;
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.searchString = "";
        this.searchFlag = false;
        this.findBalanceList();
      }
    },

    onDeleteBalance: async function(item) {
      console.log("Balance ", item);
      const confirmationResult = await confirmDelete(
        "balance",
        item.balance_date
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-balances {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
  }
}
</style>
